export default "__VITE_ASSET__BQU_6khA__"